import React from 'react'
import NotesContent from '../components/notes/NotesContent'

const AppsNotes = () => {
  return (
    <>
        <NotesContent />
    </>
  )
}

export default AppsNotes